<template>
  <TransitionRoot as="template" :show="open">
    <Dialog as="div" class="fixed z-10 inset-0 overflow-y-auto" @close="closeModal">
      <div
        class="flex items-end justify-center min-h-screen px-4 pb-20 text-center sm:block sm:p-0"
      >
        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0"
          enter-to="opacity-100"
          leave="ease-in duration-200"
          leave-from="opacity-100"
          leave-to="opacity-0"
        >
          <DialogOverlay class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </TransitionChild>

        <TransitionChild
          as="template"
          enter="ease-out duration-300"
          enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
          enter-to="opacity-100 translate-y-0 sm:scale-100"
          leave="ease-in duration-200"
          leave-from="opacity-100 translate-y-0 sm:scale-100"
          leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
        >
          <div
            class="
              inline-block
              align-bottom
              bg-white
              rounded-lg
              p-8
              absolute
              top-1/2
              left-1/2
              transform
              -translate-x-1/2 -translate-y-1/2
              text-left
              overflow-hidden
              shadow-xl
              transition-all
              sm:max-w-xl
              sm:w-full
            "
          >
            <div>
              <h2 class="text-xl leading-tight text-gray-900">
                Professionalism course required before entering a CE session.
              </h2>
              <p class="text-sm text-gray-600 mt-5">
                Ooops! Seems like you did not complete the Professionalism course before entering
                the session. The course takes 20-30 minutes, and you need a score of 100% before you
                can proceed to a session.
              </p>
            </div>
            <div class="mt-4 flex gap-2 flex-row-reverse">
              <ViceButton red small :href="url" target="_blank">Proceed to course</ViceButton>
              <ViceButton white small @click="closeModal">Cancel</ViceButton>
            </div>
          </div>
        </TransitionChild>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>
import { DialogOverlay, Dialog, TransitionChild, TransitionRoot } from '@headlessui/vue';
import ViceButton from '@/Components/Buttons/ViceButton.vue';

export default {
  name: 'CourseCompletionDialog',
  props: {
    open: {
      type: Boolean,
      required: true,
    },
    url: {
      type: String,
    },
  },
  components: {
    Dialog,
    DialogOverlay,
    TransitionChild,
    TransitionRoot,
    ViceButton,
  },
  emits: ['closeCourseCompeltionDialog'],
  methods: {
    closeModal() {
      this.$emit('closeCourseCompeltionDialog');
    },
  },
};
</script>

<style scoped></style>
